import React, {Fragment, useContext} from "react";
import PropTypes from "prop-types";
import SpinnerDiv from "root/Components/SpinnerDiv";
import PassportTable, {xlateBootstrapTableColumns} from "root/Tables/PassportTable";

import {
    defaultTableHeaderStyles,
    defaultPaginationOptions,
    customHeaderStyle,
    defaultTopLeftCellStyle,
    defaultTopRightCellStyle,
    TableActionIconView,
    TableActionIconDelete,
    TableActionIconEdit,
} from "./BaseTableComponents";

import './Table.scss'
import {getTeamRouterLink} from "root/Wieldy/routePaths";
import {UserRoleGroups, UserTypeFilters} from "root/DataFunctions/Constants";
import {ApplicationTypes, doesUserHaveApplication} from "root/DataFunctions/PageContentRoles";
import GlobalContext from "root/contexts/GlobalContext";

const TeamMemberTable = ({team_id, user_filter_type, loading, data, clickHandler}) =>
{
    const globals = useContext(GlobalContext);

    const onClickItem = (mode, user_id, userTypeId, team_id, name) =>
    {
        clickHandler(mode, user_id, userTypeId, team_id, name);
    }

    const statusFormatter = (cell, row, rowIndex, formatExtraData) =>
    {
        let color = "#216C06";

        if (cell === "Suspended" || cell === "Expired") {
            color = "#E00909";
        }

        if (cell === "Invited" || cell === "Re-invited") {
            color = "#E1720B";
        }

        return <div style={{ borderRadius: "5px", color: color }}>{cell}</div>;
    }

    const linkFormatter = (cell, row, rowIndex, formatExtraData) =>
    {
        const name = row.firstname + ' ' + row.surname;
        const link = getTeamRouterLink(team_id, 'users/' + row.user_id + '/connections?name=' + name + '&team_id=' + team_id);
        //const dashboardLink = getTeamRouterLink(team_id,'users/' + row.user_id + '/dashboard?type=summary&name=' + row.name + '&userType=' + row.userTypeId);
        //const selectedUserIsStaff = [UserTypes.ORG_MANAGER, UserTypes.LIFE_STORY_WORKER].includes(+row.userTypeId);
        const canManageAddress = UserRoleGroups.HAS_ADDRESS_MANAGED.includes(+row.userTypeId);
        //const isLetterboxAdmin = +row.approver_rights_id === UserRights.IS_LETTERBOX_ADMIN;
        const isMe = phpVars.unenc_user_id === +(row.user_id) ? true :false;
        const loggedInUserIsLetterboxAdmin = doesUserHaveApplication(ApplicationTypes.POSTBOX, globals.userType);
        const showManageConnections = user_filter_type === UserTypeFilters.STAFF && loggedInUserIsLetterboxAdmin && isMe;

        return (
            <Fragment>
                {/*user_filter_type === UserTypeFilters.CHILDREN && <TableActionIconView text="Manage Child's Connections" to={link} />*/}
                {showManageConnections && <TableActionIconView text="Manage User's Connections" to={link} />}
                {/*selectedUserIsStaff && <TableActionIconManage text="Manage User's Rights" onClick={() => onClickItem('rights',  row.user_id,null, null, row.name)} />}
                {<TableActionIconChart text="View User Stats" to={dashboardLink} />*/}
                {canManageAddress && <TableActionIconEdit text="Edit User" onClick={() => onClickItem('edit', row.user_id, row.typeName)} />}
                <TableActionIconView text="View User Details" onClick={() => onClickItem('view', row.user_id,  +(row.userTypeId), team_id)} />
                {(user_filter_type === UserTypeFilters.STAFF || user_filter_type === UserTypeFilters.CHILDREN) && <TableActionIconDelete text="Remove From Team" onClick={() => onClickItem('remove', row.user_id, null, team_id)} />}
                {/*{ row.us_description === 'Active' && <TableActionIconPassword text="Change Password" onClick={() => onClickItem('password', row.user_id)} />}
                { (row.us_description === 'Invited' || row.us_description === 'Re-invited' || row.us_description === 'Expired') && <TableActionIconEmail text="Invite Again" onClick={() => onClickItem('invite', row.user_id)} />}
                { row.us_description === 'Active' && <TableActionIconSuspend text="Suspend User" onClick={() => onClickItem('suspend', row.user_id)} />}
                { row.us_description === 'Suspended' && <TableActionIconActivate text="Activate User" onClick={() => onClickItem('activate', row.user_id)} />*/}
            </Fragment>
        );
    }

    const headerStyle = customHeaderStyle.bind(null, {
        default: defaultTableHeaderStyles,
        firstname: {borderRadius: defaultTopLeftCellStyle, width: "10vw"},
        surname: { width: "10vw"},
        us_description: {},
        typeName: {width: "10vw"},
        options: {borderRadius: defaultTopRightCellStyle, textAlign: 'right', width: "14vw"}
    });

    const getColumns = () => {
        const columns = [
            {
                dataField: "firstname",
                text: "Firstname",
                headerStyle: headerStyle
            },
            {
                dataField: "surname",
                text: "Surname",
                sort: true,
                headerStyle: headerStyle
            },
            {
                dataField: "typeName",
                text: "User Type",
                headerStyle: headerStyle
            },
            {
                dataField: "us_description",
                text: "Account Status",
                formatter: statusFormatter,
                headerStyle: headerStyle
            },
            {
                dataField: "options",
                text: "Options",
                formatter: linkFormatter,
                align: 'right',
                headerStyle: headerStyle
            },
        ];

        return columns;
    };

    const translations = xlateBootstrapTableColumns(getColumns());
    const columns = React.useMemo(() => translations, [user_filter_type, team_id]);

    const thisTableContent = () =>
    {
        return <PassportTable data={data} columns={columns} pagination={defaultPaginationOptions}/>
    }

    return loading === true ? <SpinnerDiv/> : thisTableContent();
};

export default TeamMemberTable;

TeamMemberTable.propTypes = {
    team_id: PropTypes.string,
    data: PropTypes.array,
    loading: PropTypes.bool
};
